import { jsx as o } from "react/jsx-runtime";
import { Modal as t } from "../Modal/index.js";
const i = (r) => /* @__PURE__ */ o(t, { ...r, isAlert: !0 });
export {
  i as Alert
};
